import React, { useState, useContext } from "react";
import { Route, Navigate, Routes, useLocation } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import ProductForm from "./components/ProductForm";
import ProductImport from "./components/ProductImport";
import StockEntry from "./components/StockEntry";
import StockExit from "./components/StockExit";
import InventoryList from "./components/InventoryList";
import Alerts from "./components/Alerts";
import BatchReport from "./components/BatchReport";
import StockMovementReport from "./components/StockMovementReport";
import CostVariationReport from "./components/CostVariationReport";
import StockValueReport from "./components/StockValueReport";
import AdminUsers from "./components/AdminUsers";
import PurchasePrediction from './components/PurchasePrediction';
import ShoppingDashboard from './components/ShoppingDashboard';
import FichasTecnicasList from './components/FichasTecnicasList';
import FichaTecnicaForm from './components/FichaTecnicaForm';
import FichaTecnicaDetalhes from './components/FichaTecnicaDetalhes';
import Embalagens from './components/Embalagens';
import ProdutosSemControleList from './components/ProdutosSemControleList';
import GuiaTamanhos from './components/GuiaTamanhos';
import GuiaRecheios from './components/GuiaRecheios';
import GuiaCombinacoes from './components/GuiaCombinacoes';
import GuiaMenuFixo from './components/GuiaMenuFixo';
import GuiaProducaoSemanal from './components/GuiaProducaoSemanal';
import GuiaMontagemDiaria from './components/GuiaMontagemDiaria';

import "./App.css";

function App() {
  const { isAuthenticated, isAdmin, login, logout } = useContext(AuthContext);
  const [editProduct, setEditProduct] = useState(null);
  const location = useLocation();

  const isLoginPage = location.pathname === "/login";

  const handleEditProduct = (produto) => {
    setEditProduct(produto);
  };

  const PrivateRoute = ({ element }) => {
    return isAuthenticated ? element : <Navigate to="/login" />;
  };

  const AdminRoute = ({ element }) => {
    return isAuthenticated && isAdmin ? element : <Navigate to="/" />;
  };

  return (
    <>
      {!isLoginPage && <Navbar isAuthenticated={isAuthenticated} isAdmin={isAdmin} onLogout={logout} />}
      <div className={isLoginPage ? "" : "container mx-auto mt-6"}>
        <Routes>
          <Route path="/login" element={<Login onLoginSuccess={login} />} />

          <Route path="/" element={<PrivateRoute element={<InventoryList onEditProduct={handleEditProduct} />} />} />
          <Route path="/produtos" element={<PrivateRoute element={<ProductForm produtoEditado={editProduct} />} />} />
          <Route path="/produtos-sem-controle" element={<PrivateRoute element={<ProdutosSemControleList />} />} />
          <Route path="/embalagens" element={<PrivateRoute element={<Embalagens />} />} />

          <Route path="/entrada" element={<PrivateRoute element={<StockEntry />} />} />
          <Route path="/saida" element={<PrivateRoute element={<StockExit />} />} />

          <Route path="/estoque" element={<PrivateRoute element={<InventoryList onEditProduct={handleEditProduct} />} />} />
          <Route path="/alertas" element={<PrivateRoute element={<Alerts />} />} />
          <Route path="/lotes" element={<PrivateRoute element={<BatchReport />} />} />
          <Route path="/movimentacoes" element={<PrivateRoute element={<StockMovementReport />} />} />
          <Route path="/variacao-custo" element={<PrivateRoute element={<CostVariationReport />} />} />
          <Route path="/valor-estoque" element={<PrivateRoute element={<StockValueReport />} />} />
          <Route path="/prediction" element={<PrivateRoute element={<PurchasePrediction />} />} />
          <Route path="/lista-compras" element={<PrivateRoute element={<ShoppingDashboard />} />} />

          <Route path="/fichas-tecnicas" element={<PrivateRoute element={<FichasTecnicasList />} />}/>
          <Route path="/fichas-tecnicas/nova" element={<PrivateRoute element={<FichaTecnicaForm />} />} />
          <Route path="/fichas-tecnicas/:id/editar" element={<PrivateRoute element={<FichaTecnicaForm />} />} />
          <Route path="/fichas-tecnicas/:id" element={<PrivateRoute element={<FichaTecnicaDetalhes />} />} />

          <Route path="/guia/tamanhos" element={<PrivateRoute element={<GuiaTamanhos />} />} />
          <Route path="/guia/recheios" element={<PrivateRoute element={<GuiaRecheios />} />} />
          <Route path="/guia/combinacoes" element={<PrivateRoute element={<GuiaCombinacoes />} />} />
          <Route path="/guia/menu-fixo" element={<PrivateRoute element={<GuiaMenuFixo />} />} />

          <Route path="/guia/producao" element={<PrivateRoute element={<GuiaProducaoSemanal />} />} />
          <Route path="/guia/montagem" element={<PrivateRoute element={<GuiaMontagemDiaria />} />} />

          <Route path="/importar" element={<PrivateRoute element={<ProductImport />} />} />
          <Route path="/admin" element={<AdminRoute element={<AdminUsers />} />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
